import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/api-client';
import type { Owner } from './use-expenses-list';

/**
 * `GET /v1/expenses/people`: whom the «Utente» filter offers, read once the list has said the
 * caller may filter by owner. `null` until it answers, and when it cannot: the caller then falls
 * back to the list's own `owners`, then to the owners seen in the rows.
 */
export function useExpensePeople(enabled: boolean): readonly Owner[] | null {
  const [people, setPeople] = useState<readonly Owner[] | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    apiClient
      .GET('/v1/expenses/people')
      .then(({ data, error, response }) => {
        if (!active || error !== undefined || !response.ok) return;
        const items = (data as { items?: unknown } | undefined)?.items;
        if (Array.isArray(items) && items.every(isPerson)) setPeople(items);
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [enabled]);

  return enabled ? people : null;
}

function isPerson(value: unknown): value is Owner {
  if (typeof value !== 'object' || value === null) return false;
  const { userId, displayName } = value as Record<string, unknown>;
  return typeof userId === 'string' && typeof displayName === 'string';
}
